import { ErrorCode } from '@mogul/api-client';
import { parseApiErrors } from '@mogul/shared';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';

import { viewerApi } from '../../api';
import { useAuth } from '../../auth';
import { OkModal } from '../../components/common/modal/OkModal.component';
import { RegisterTwoFactorAuthComponent } from '../../components/register-two-factor-auth/RegisterTwoFactorAuth.component';
import { ModalStateContext } from '../../contexts/app-state-context/modal-state.context';

export const TwoFactorAuth = () => {
  const { setModal } = useContext(ModalStateContext);

  const { verifyMfa } = useAuth();

  const [otpAuthUrl, setOtpAuthUrl] = useState<string | undefined>();

  const history = useHistory();

  const handleSkip = () => {
    void viewerApi.updateViewerPreferences({
      userPreferencesUpdateData: { mfaPrompt: false },
    });
    history.push('/platform/dashboard');
  };

  const handleInit = () =>
    viewerApi.initMfa().then(
      response => setOtpAuthUrl(response.data.data.authUrl),
      error => {
        for (const { code } of parseApiErrors(error)) {
          if (code === ErrorCode.UserMfaActive) {
            setModal(OkModal('Error Initializing Two Factor Auth'));
            return;
          }
        }

        throw error;
      },
    );

  const handleVerify = (otpCode: string) =>
    verifyMfa({ otpCode }).catch(error => {
      for (const { code, detail } of parseApiErrors(error)) {
        if (code === ErrorCode.AuthUnauthorized) {
          setModal(OkModal(detail ?? 'Invalid code'));
          return;
        }
      }
    });

  return (
    <>
      <RegisterTwoFactorAuthComponent
        otpAuthUrl={otpAuthUrl}
        onInit={handleInit}
        onVerify={handleVerify}
        onSkip={handleSkip}
      />
    </>
  );
};
